import * as React from "react";
import BaseUI, { IBaseUI } from "src/engine/ui/BaseUI";
import { Flex as AntFlex } from "antd-mobile";
import UIManifest from "src/engine/ui/UIManifest";
import { IPanelContext } from "src/engine/context/PanelContext";
import IUIItem from "src/engine/interface/IUIItem";
import "./Flex.scss";

interface IFlex extends IBaseUI {
    direction?: "row" | "row-reverse" | "column" | "column-reverse";
    justify?: "start" | "end" | "center" | "between" | "around";
    align?: "start" | "center" | "end" | "baseline" | "stretch";
    alignContent?: "start" | "end" | "center" | "between" | "around" | "stretch";
    ratio?: number[];
    ratioString?: string;
    style?: any;
}

export const Item = AntFlex.Item;

@UIManifest.declareGG(["ggValue", "dataValue"], "Flex")
class Flex extends BaseUI<IFlex> {
    renderUIItem(uiItem: IUIItem, context: IPanelContext, props: any = {}) {
        let { ratio = [] } = this.props;
        const { ratioString } = this.props;
        if (ratioString) {
            const ratioStringArray: number[] = [];
            ratioString.split(",").forEach((s: string) => {
                const num = Number(s);
                if (typeof num === "number") {
                    ratioStringArray.push(num);
                }
            });
            ratio = ratioStringArray;
        }
        if (ratio.length > 0) {
            return (
                <AntFlex.Item key={props.key || uiItem.info.ename} flex={ratio[props.index % ratio.length]}>
                    {super.renderUIItem(uiItem, context, props)}
                </AntFlex.Item>
            );
        }
        return super.renderUIItem(uiItem, context, props);
    }

    renderList() {
        const { uiItem } = this.props;
        if (uiItem.dataSource || Array.isArray(this.props.data)) {
            return this.renderDataItems();
        } else {
            return this.renderChildren();
        }
    }

    render() {
        const { uiItem, _updateKey, editId, ratioString, ...other } = this.props as any;

        return (
            <AntFlex {...other} style={this.getStyle()}>
                {this.renderList()}
            </AntFlex>
        );
    }
}

export default Flex;
